var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Process } from "../process/process.cls";
/**
 * Basic implementation for a WebSocket wrapper
 */
var WsConnector = /** @class */ (function (_super) {
    __extends(WsConnector, _super);
    function WsConnector() {
        var _this = _super.call(this, null) || this;
        // HTML5 WebSocket
        _this.ws = null;
        // saves the timeout state - pause between re-connects
        _this.timeoutTrigger = null;
        _this.timeoutTriggerStatus = null;
        _this.timeoutStatusInterval = 10000;
        _this.timeoutTriggerDisconnect = null;
        // current number of retries to connect to the websocket
        _this.currentRetry = 0;
        // default handlers
        _this.onopen = function (ev) { _this.log(WsConnector.TAG, 'DEF open...', ev); };
        _this.onclose = function (ev) { _this.log(WsConnector.TAG, 'DEF close...', ev); };
        _this.onconnecting = function () { _this.log(WsConnector.TAG, 'DEF connecting...'); };
        _this.onmessage = function (ev) { _this.log(WsConnector.TAG, 'DEF onmessage...', ev); };
        _this.onerror = function (event) { return _this.handleError; };
        /**
         * connect websocket
         */
        _this.connect = function () {
            try {
                // if websocket is already connected - close it
                _this.stop();
                // construct full url t owebsocket
                var wsurl = _this.settings.ENDPOINT + _this.buildQuery();
                _this.onconnecting();
                // init webocket
                _this.ws = new WebSocket(wsurl);
                // overide handlers
                _this.ws.onopen = _this.onopen;
                _this.ws.onmessage = _this.onmessage;
                _this.ws.onerror = function (event) {
                    // this.connect()
                    _this.handleError(event);
                };
                _this.checkStatus();
                // console.log(this.ws.readyState)
            }
            catch (ex) {
                _this.handleError(ex);
            }
        };
        _this.checkStatus = function () {
            var _her = _this;
            if (_this.timeoutTriggerStatus !== null) { // clear timeout
                clearTimeout(_this.timeoutTriggerStatus);
                _this.timeoutTriggerStatus = null;
            }
            _this.timeoutTriggerStatus = setInterval(function () {
                if (_her.ws.readyState == 2 || _her.ws.readyState == 3) {
                    _her.connect();
                    _her.timeoutStatusInterval = 10000;
                    _her.checkStatus();
                    // _her.handleDisconnect()
                }
                else if (_her.ws.readyState == 0) {
                    _her.timeoutStatusInterval = 20000;
                    _her.checkStatus();
                }
                else if (_her.ws.readyState == 1) {
                    _her.timeoutStatusInterval = 500;
                    _her.checkStatus();
                }
            }, _her.timeoutStatusInterval);
        };
        /**
         * handle errors and invoke re-ceonncting if configured
         * and we haven't reached number of max retries
         */
        _this.handleError = function (event) {
            try {
                if (_this.settings.maxRetries == 0
                    || _this.currentRetry < _this.settings.maxRetries) { // less than max-retries?
                    _this.currentRetry++;
                    _this.log(WsConnector.TAG, '[' + _this.currentRetry + 'of' +
                        _this.settings.maxRetries + '] try again in handle error' + _this.settings.reconnectInterval + ' ms');
                    if (_this.timeoutTrigger !== null) { // clear timeout
                        clearTimeout(_this.timeoutTrigger);
                        _this.timeoutTrigger = null;
                    }
                    // set new timeout before next re-connect	
                    _this.timeoutTrigger = setTimeout(function () {
                        _this.connect();
                    }, _this.settings.reconnectInterval);
                }
                else { // already reached max
                    _this.log(WsConnector.TAG, 'failed to connect websocket after in handle error' +
                        _this.settings.maxRetries + ' tries');
                    try {
                        _this.stop();
                    }
                    catch (fini) {
                        _this.log(WsConnector.TAG, 'websocket closing');
                        // final chutdown of websocket
                    }
                }
            }
            catch (exo) {
                _this.log(WsConnector.TAG, 'handleError', exo);
                _this.onerror(exo);
            }
        };
        _this.handleDisconnect = function () {
            try {
                if (_this.settings.maxRetries == 0
                    || _this.currentRetry < _this.settings.maxRetries) { // less than max-retries?
                    _this.currentRetry++;
                    _this.log(WsConnector.TAG, '[' + _this.currentRetry + 'of' +
                        _this.settings.maxRetries + '] try again in ' + _this.settings.reconnectInterval + ' ms');
                    // set new timeout before next re-connect 
                    _this.connect();
                }
                else { // already reached max
                    _this.log(WsConnector.TAG, 'failed to connect websocket after' +
                        _this.settings.maxRetries + ' tries');
                    try {
                        _this.stop();
                    }
                    catch (fini) {
                        _this.log(WsConnector.TAG, 'websocket closing');
                        // final chutdown of websocket
                    }
                }
            }
            catch (exo) {
                _this.log(WsConnector.TAG, 'handleError', exo);
                _this.onerror(exo);
            }
        };
        _this.waitForSocketConnection = function (socket, data, callback) {
            setTimeout(function () {
                try {
                    if (socket.readyState === 1) {
                        if (callback != null) {
                            callback(data);
                        }
                        return;
                    }
                    else {
                        _this.waitForSocketConnection(socket, data, callback);
                    }
                }
                catch (ex) {
                    _this.waitForSocketConnection(socket, data, callback);
                }
            }, 5);
        };
        _this.log(WsConnector.TAG, _this.settings);
        return _this;
    }
    /**
     * start process thread
     * used by caches and providers and mains to start all
     * registered providers and caches
     * @param params
     */
    WsConnector.prototype.start = function (params) {
        this.log(WsConnector.TAG, 'start', params);
        this.settings = params;
        // overide handlers from config
        this.onopen = this.settings.onopen || this.onopen;
        this.onclose = this.settings.onclose || this.onclose;
        this.onconnecting = this.settings.onconnecting || this.onconnecting;
        this.onmessage = this.settings.onmessage || this.onmessage;
        // connect websocket
        this.connect();
    };
    /**
     * stop process thread
     * used by caches and providers and mains to stop all
     * registered providers and caches
     * @param params
     */
    WsConnector.prototype.stop = function (params) {
        this.log(WsConnector.TAG, 'stopping websocket...');
        this.close();
    };
    /**
     * authenticate
     * @param params must contain credentials in case auth is needed
     */
    WsConnector.prototype.auth = function (params) { };
    /**
     * build query in case there are request params
     * in the configuration
     */
    WsConnector.prototype.buildQuery = function () {
        var q = ''; // optional query string
        if (!this.settings.hasOwnProperty('query')) {
            return q;
        }
        if ('query' in this.settings) {
            for (var key in this.settings.query) {
                q += key + '=' + this.settings.query[key] + '&';
            }
        }
        q = (q.length > 1) ? '?' + q.substring(0, q.length - 1) : '';
        return q;
    };
    /**
     * ssend data message to websocket
     * @param data
     */
    WsConnector.prototype.send = function (data) {
        var _this = this;
        if (this.ws.readyState === 1) {
            return this.ws.send(data);
        }
        else {
            this.waitForSocketConnection(this.ws, data, function (data) {
                try {
                    if (_this.ws.readyState === 1) {
                        _this.log(WsConnector.TAG, 'send', { endpoint: _this.settings.ENDPOINT, data: data });
                        console.log(WsConnector.TAG, data);
                        return _this.ws.send(data);
                    }
                    else {
                        console.log("this.ws.readyState", _this.ws.readyState);
                        // this.connect()
                    }
                }
                catch (ex) {
                    _this.log(WsConnector.TAG, 'send', ex.message);
                }
            });
        }
    };
    /**
     * close websocket
     */
    WsConnector.prototype.close = function () {
        try {
            this.ws.close();
            this.ws = null;
        }
        catch (ex) {
            this.ws = null;
        }
        this.log(WsConnector.TAG, 'stopping websocket ... done');
    };
    // name of the websocket
    WsConnector.TAG = 'WsConnector';
    return WsConnector;
}(Process));
export { WsConnector };



//////////////////
// WEBPACK FOOTER
// ./src/plugins/lib/ws/ws-connector.cls.ts
// module id = p8Yw
// module chunks = 76